/**
 * POST /auth/forgot-password - Request password reset
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import type { AuthService } from '../auth.service.js'
import type { ForgotPasswordInput, AuthConfig } from '../auth.types.js'
import { getRequestInfo } from './helpers.js'
import { verifyCaptcha } from '../captcha.js'

export const forgotPasswordAction: ActionDefinition = {
  key: 'forgot-password',
  label: { en: 'Forgot Password', es: 'Olvidé mi contraseña' },
  icon: 'mdi:lock-question',
  scope: 'module',
  group: { en: 'Authentication', es: 'Autenticación' },
  method: 'POST',
  skipAuth: true,
  middleware: (ctx) => (ctx.services.get('authRateLimits') as { login: MiddlewareHandler }).login,
  input: {
    email: { input: 'email', required: true, label: { en: 'Email', es: 'Correo electrónico' } },
    captchaToken: { input: 'text', label: { en: 'CAPTCHA Token', es: 'Token CAPTCHA' }, hidden: true }
  },
  handler: async (ctx, input, c) => {
    const body = input as ForgotPasswordInput
    const authCfg = ctx.services.get<AuthConfig>('authConfig')
    const authService = ctx.services.get<AuthService>('auth')

    // CAPTCHA verification (before business logic)
    if (authCfg.captchaProvider !== 'none' && authCfg.captchaSecretKey && authCfg.captchaOnForgotPassword) {
      const captchaError = await verifyCaptcha(body.captchaToken, {
        provider: authCfg.captchaProvider,
        secretKey: authCfg.captchaSecretKey
      }, { logger: ctx.core.logger })
      if (captchaError) throw new ctx.core.errors.ValidationError(captchaError)
    }

    await authService.forgotPassword(body, getRequestInfo(c))
    return { message: 'If this email exists, a verification code has been sent' }
  }
}
